import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import { getlocalStorage } from "@/Utils/localStorage";
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 })
});
const whiteList = ["/login"];
router.beforeEach((to, from, next) => {
  next();
});

export default router;
